// extracted by mini-css-extract-plugin
export default {"dailyTimeReport":"DailyTimeReport_dailyTimeReport__x7Cva"};